import { GENERAL_ERROR_ADD, GENERAL_ERROR_REMOVE } from "../constants";

export const error = (state = {}, action) => {
    const { error } = action.payload;
    
    if (!error) {
        return state;
    }
    if (error.modelState) {
        return error.modelState;
    }
    if (error.name === 'ValidationError') {
        if (error.path) {
            return {
                [error.path]: error.errors,
            };
        }
        if (error.inner.length > 0) {
            return error.inner.reduce((obj, item) => {
                obj[item.path] = item.errors;
                return obj;
            }, {});
        }
    }
    if (typeof error === 'object') {
        const errorFormatted = {};
        Object.keys(error).forEach((key) => {
            errorFormatted[_camelCase(key)] = error[key];
        });
        return errorFormatted;
    }

    return state;
};

const _camelCase = (input) => {
    if (typeof input !== 'string') return '';
    return input.charAt(0).toLocaleLowerCase() + input.slice(1);
};

export const generalErrors = (state = {}, action) => {
    switch (action.type) {
        case GENERAL_ERROR_ADD:
            return {
                ...state,
                ...action.payload,
            };
        case GENERAL_ERROR_REMOVE:
            return {
                errors: state?.errors?.filter(m => m.messageId !== action.payload)
            }
            return result;
        default:
            return state;
    }
}